export const APP_PATH = new URL(document.baseURI).pathname;

export const url = (path: string) =>
  new URL(path.replace(/^\/+/, ""), document.baseURI).href;
